export const siteWeightOptions = [
  {
    label: '5',
    value: '5',
  },
  {
    label: '4',
    value: '4',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '1',
    value: '1',
  },
];
